/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type QAStatusInput = {
    status: QAStatusInput.status;
};
export namespace QAStatusInput {
    export enum status {
        OPEN = 'open',
        ANSWERED = 'answered',
        HIDDEN = 'hidden',
    }
}

